<div class="page-title-bar mb-4 flex-sm-row flex-column flex-wrap d-flex justify-content-between align-items-start">
    <div class="title d-flex align-items-center">
      <button *ngIf="showBackButton" mat-icon-button (click)="backButton()" class="me-3">
        <mat-icon class="material-icons-round">arrow_back</mat-icon>
      </button>
      <div>
        <h1 *ngIf="pageTitle">{{pageTitle |titlecase}}</h1>
        <h2 class="m-0" *ngIf="pageSubTitle">{{pageSubTitle}}</h2>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="headerCustomTemplate"></ng-container>
    
    <button *ngIf="showButton" mat-button (click)="onTitlebarButtonClick()">{{showButton}}</button>
  </div>
  